
// This file provides backward compatibility for components that still import from the old location
import { toastService } from "@/utils/toastService";

interface ToastProps {
  variant?: 'default' | 'destructive';
  title?: string;
  description?: string;
}

// Create a backward-compatible interface
const useToast = () => ({
  toast: (props: ToastProps) => {
    if (props.variant === 'destructive') {
      return toastService.error(props.description || props.title || '');
    }
    return toastService.info(props.description || props.title || '');
  },
  dismiss: toastService.dismiss
});

// Export a simple toast function that maps to toastService
const toast = (props: ToastProps) => {
  if (props.variant === 'destructive') {
    return toastService.error(props.description || props.title || '');
  }
  return toastService.info(props.description || props.title || '');
};

export { useToast, toast };
